import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, Search, Camera } from "lucide-react";

const links = [
  { to: "/catalog", label: "Catalog" },
  { to: "/timeline", label: "Timeline" },
  { to: "/designers", label: "Designers" },
  { to: "/movements", label: "Movements" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/catalog?search=${encodeURIComponent(q.trim())}`);
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-6">
        <Link to="/" className="serif text-2xl tracking-tight font-semibold" data-testid="logo-link">
          The Chair <span className="text-accent">Index</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-accent ${isActive ? "text-accent" : "text-foreground"}`
              }
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <form onSubmit={submit} className="hidden lg:flex items-center border border-border bg-card px-3 h-9">
            <Search size={15} className="text-muted-foreground" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search chairs…"
              className="bg-transparent outline-none text-sm px-2 w-40"
              data-testid="header-search-input"
            />
          </form>
          <Link
            to="/identify"
            className="hidden sm:inline-flex items-center gap-2 bg-accent text-accent-foreground text-sm font-medium px-4 h-9 hover:bg-[hsl(var(--accent))]/90 transition-colors"
            data-testid="nav-identify"
          >
            <Camera size={15} /> Identify
          </Link>
          <button
            onClick={() => setOpen((o) => !o)}
            className="md:hidden p-2 -mr-2"
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background px-5 py-6 space-y-5" data-testid="mobile-menu">
          <form onSubmit={submit} className="flex items-center border border-border bg-card px-3 h-11">
            <Search size={16} className="text-muted-foreground" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search chairs…"
              className="bg-transparent outline-none text-sm px-2 w-full"
            />
          </form>
          {links.concat({ to: "/identify", label: "Identify a Chair" }).map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block serif text-2xl"
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/ /g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
};
